import { Injectable} from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map} from 'rxjs/operators';
import { ApiService } from './services/api.service';
import { BehaviorSubject } from 'rxjs';
import { SessionService } from './services/session.service';
import { LoaderService } from './services/loader.service';
import { tookanResponse } from './constants/constant';
import { environment } from '../environments/environment';

@Injectable()
export class AppService {
  public notDeliverable = new BehaviorSubject({});
  public showMainPopup : boolean;
  constructor(
    private api: ApiService,
    private http: HttpClient,
    private sessionService: SessionService,
    private loaderService: LoaderService
  ) {
    window['s'] = this;
  }

  /**
   * notdeliverable input 
   */
  notDelivered(data) {
    this.notDeliverable.next(data)
  }

  fetchAppConfiguration() {
    const obj = {
      url: 'marketplace_fetch_app_configuration',
      body: {}
      // 'headers': this.headers
    };
    return this.api.get(obj);
  }


  flightmap_reverse_geocode(lngLat) {
    const data = {
      lat: lngLat.lat,
      lng: lngLat.lng,
      user_unique_key: this.sessionService.get('config').marketplace_user_id.toString(),
      language:this.sessionService.getString('language') || 'en',
      zoom: '18'
    };
    data['fm_token'] = this.sessionService.get('config').map_object.webapp_map_api_key || environment.defaultMapprKey;
    return this.http.get(`${environment.maps_api_url}/search_reverse`, { params: new HttpParams({ fromObject: data }) }).pipe(
      map(this.tookanResponse).bind(this))
  }

  fetchTemplates(user_id, preview_theme_id, pageName?) {
    const obj: any = {
      url: 'themes/getComponentsByPage',
      body: {
        name: pageName || 'home',
        component_data: 1,
        marketplace_user_id: user_id,
        post_to_get: 1,
        noDualUser: 1
      }
    };
    if (preview_theme_id) {
      obj.body.theme_id = preview_theme_id;
      // 'headers': this.headers
    }

    return this.api.get(obj);
  }


  getAddressFromIp() {
    const url = 'https://ipinfo.io/?callback=';
    return this.http.get(url).pipe(map(tookanResponse));
    // .map(response => {this.langData = response.json();});
  }


  getAddonConfig() {
    const obj: any = {
      url: 'addOn/get',
      body: {}
    };
    return this.api.get(obj);
  }

  getAlternateIP() {
    return this.http
      .get("https://api.ipify.org/?format=json")
      .pipe(map((res: any) => res));
  }
  tookanResponse(res: any) {
    return res;
  }

  hitLanguageStrings() {
    let resolve, reject;
    this.sessionService.langStringsPromise = new Promise((res, rej) => {
      resolve = res;
      reject = rej;
    });
    const obj = {
      url: environment.production ? '/getAccountTranslations' : 'getAccountTranslations',
      body: {}
    };
    this.loaderService.show();
    this.api.post_test(obj).subscribe((response)=>{
      setTimeout(() =>{
        this.sessionService.languageStrings = response.data.language_strings;
        this.sessionService.languageStrings['Phone No.']=  this.sessionService.languageStrings['Phone No.'] || 'Phone No.';
        this.sessionService.languageStrings['Log in']=  this.sessionService.languageStrings['Log in'] || 'Log in';
        this.sessionService.languageStrings['Login']=  this.sessionService.languageStrings['Log in'] || 'Log in';      
        resolve(true);
        this.loaderService.hide();
      },0);
    })

  }
  getTickerData(){
    const obj  ={
        "vendor_id": this.sessionService.get('appData').vendor_details.vendor_id,
        "access_token": this.sessionService.get('appData').vendor_details.app_access_token,
        "marketplace_user_id": this.sessionService.get('config').marketplace_user_id, 
        "language" :this.sessionService.getString('language') || 'en'
    }
    const apiObj = {
      url: 'v2/task/getOngoingOrders',
      'body': obj,
    };
    return this.api.postWithoutDOmain(apiObj);
  }
  // THIS API IS USED FOR BREWSAGE THEME TO GET THE MERCHANT CATEGORIES IN HOME PAGE
  getAllCategory(data) {
    const obj = {
      'url': 'catalogue/get',
      'body': data || {},
    };
    return this.api.post(obj);
  }
  // THIS API IS USED FOR BREWSAGE THEME TO GET THE PRODUCT TAGS 
   getProductTags(data){
    const body = {
      'user_id':data.user_id,
      'limit': data.limit,
      'marketplace_user_id':this.sessionService.get('config').marketplace_user_id,
    };
    const obj = {
      'url': 'getAllProductTags',
      'body': body,
    };
    return this.api.post(obj);
  }
    // THIS API IS USED FOR BREWSAGE THEME TO GET THE PRODUCT TAGS PRODUCTS 
  getProductOfTags(data){
    const body = {
      'marketplace_user_id':this.sessionService.get('config').marketplace_user_id,
      "sortedData" : 1,
      ...data
    };
    if(this.sessionService.get('config').is_customer_login_required && this.sessionService.get('appData')){
      body['vendor_id'] = this.sessionService.get('appData').vendor_details.vendor_id;
      body['access_token'] = this.sessionService.get('appData').vendor_details.app_access_token;
    }
    const obj = {
      'url': 'getSelectedTagProducts',
      'body': body,
    };
    return this.api.post(obj);
  }
}
